<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="sf-actions">
					<div className="sf-actions_left">
						<!--임시저장-->
						<!-- <sf-button size="sm" v-if="rtnPartInfo.btnTsAuth2" line icon="file" :onClick="tmpSaveAction">
							{{ getMessage_('QWCC001004') }}
						</sf-button> -->
						<!--제출 AP--임시 신청값-->
						<sf-button size="sm" v-if="rtnPartInfo.btnApAuth2" line icon="round-check-on" :onClick="ApcnAction">
							{{ getMessage_('QWCC001269') }}
						</sf-button>
					</div>
				</div>
			</div>

			<div class="sf-card__header">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001262') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--발신자-->
							<th class="col-1">* {{ getMessage_('QWCC001263') }}</th>
							<td class="col-1">
								<el-input
									:value="rtnPartInfo.dsprNm"
									maxlength="6"
									:readonly="rtnPartInfo.readOnlyAuth2"
									@input="val => onChangeSelect(val, 'dsprNm')"
								/>
							</td>
							<!--발신자 연락처-->
							<th class="col-1">* {{ getMessage_('QWCC001264') }}</th>
							<td class="col-1">
								<el-input
									:value="rtnPartInfo.dsprTel"
									:readonly="rtnPartInfo.readOnlyAuth2"
									maxlength="30"
									@input="val => onChangeSelect(val, 'dsprTel')"
								/>
							</td>
							<template v-if="rtnPartInfo.clctWay == null || rtnPartInfo.clctWay == '10'">
								<!--택배번호-->
								<th class="col-1">* {{ getMessage_('QWCC001230') }}</th>
								<td class="col-1">
									<el-input
										:value="rtnPartInfo.dlvsNo"
										maxlength="30"
										:readonly="rtnPartInfo.readOnlyAuth2"
										@input="val => onChangeSelect(val, 'dlvsNo')"
									/>
								</td>
							</template>
							<template v-else>
								<!--회수자-->
								<th class="col-1">* {{ getMessage_('QWCC001905') }}</th>
								<td class="col-1">
									<el-input
										:value="rtnPartInfo.clctNm"
										maxlength="6"
										:readonly="rtnPartInfo.readOnlyAuth2"
										@input="val => onChangeSelect(val, 'clctNm')"
									/>
								</td>
							</template>
							<!--택배비여부-->
							<template v-if="rtnPartInfo.clctWay == null || rtnPartInfo.clctWay == '10'">
								<th class="col-1">{{ getMessage_('QWCC001265') }}</th>
								<td class="col-1">
									<el-select v-model="rtnPartInfo.dlvfYn" @change="changeDlvfYn" :disabled="rtnPartInfo.readOnlyAuth2">
										<el-option :label="getMessage_('QWCC001265')" value=""></el-option>
										<el-option
											:key="index"
											v-for="(result, index) in dlvfYnList"
											:label="result.commCdName"
											:value="result.commCd"
										></el-option>
									</el-select>
								</td>
							</template>
							<template v-else>
								<th class="col-1"></th>
								<td class="col-1"></td>
							</template>
						</tr>
						<tr>
							<!--비고-->
							<th class="col-1">{{ getMessage_('QWCC000906') }}</th>
							<td class="col-1" colspan="7">
								<el-input
									:value="rtnPartInfo.rson"
									maxlength="300"
									:readonly="rtnPartInfo.readOnlyAuth2"
									@input="val => onChangeSelect(val, 'rson')"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({
				dsprTel: yup //발신자 연락처
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001264')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001264')])),
				dsprNm: yup //발신자
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001263')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001263')]))
			});
		},
		insVali1() {
			return yup.object().shape({
				dlvsNo: yup //택배번호
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001230')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001230')]))
			});
		},
		insVali2() {
			return yup.object().shape({
				clctNm: yup //회수자
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001905')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001905')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangeSelect(value, key) {
			if (key === 'dsprTel') {
				value = value?.length > 60 ? value.slice(0, 60) : value;
			}
			this.setRtnPartInfo_({ key, value });
		},
		changeDlvfYn(value) {
			//택배비지불
			this.setRtnPartInfo_({ key: 'dlvfYn', value });
		},
		tmpSaveAction() {
			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.save }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async save() {
			this.$sf_toggleLoading(true);
			const saveParams = this.rtnPartInfo;
			const params = { saveParams: saveParams };
			await this.UpdateRtnPartInfo_(params)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			const rtnPartInfo = this.rtnPartInfo;
			await this.getRtnPartInfo_(rtnPartInfo);
			this.$sf_toggleLoading(false);
		},
		ApcnAction() {
			try {
				const saveParams = this.rtnPartInfo;
				//벨리데이션 체크
				if (this.rtnPartInfo.clctWay == '10') {
					this.insVali.validateSync(saveParams);
					this.insVali1.validateSync(saveParams);
				} else {
					this.insVali.validateSync(saveParams);
					this.insVali2.validateSync(saveParams);
				}

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001283'), //제출하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001284'), clickFn: this.apcn }] //제출
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async apcn() {
			const rptpNo = this.rtnPartInfo.rptpNo;
			await this.setRtnPartInfo_({ key: 'rptpSt', value: 20 });
			const saveParams = this.rtnPartInfo;
			const params = { rptpNo: rptpNo, saveParams: saveParams };

			await this.UpdateRtnPartInfo_(params)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});

			const rtnPartInfo = this.rtnPartInfo;
			await this.getRtnPartInfo_(rtnPartInfo);
			this.$sf_toggleLoading(false);
		}
	},
	async created() {
		this.$sf_toggleLoading(true);
		await this.getCommCodes_({ key: 'dlvfYnList', codeType: 'EXP_PAY' }); //택배비지불 콤보박스
		//회수방법 직접회수시 택배비지불 = ''
		if (this.rtnPartInfo.clctWay == '20') {
			this.setRtnPartInfo_({ key: 'dlvfYn', value: '' });
		}
		this.$sf_toggleLoading(false);
	},
	watch: {}
};
</script>
